<p-dialog *ngIf="kitchenDevice" [(visible)]="kitchenDevice" [closable]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'tablet']" class="me-4" size="lg"></fa-icon>
		FocusKitchen {{ kitchenDevice.name?.toUpperCase() || kitchenDevice.key.substring(kitchenDevice.key.length - 8) }}
	</ng-template>

	<div class="d-flex flex-wrap">
		<div class="flex-fill mx-2 mt-4">
			<span class="p-float-label">
				<input
					pInputText
					type="text"
					id="licenseName"
					name="licenseName"
					[(ngModel)]="kitchenDevice.name"
					class="w-100"
					(change)="changesToSave = true"
				/>
				<label for="licenseName">Device Name</label>
			</span>
		</div>
		<div class="flex-fill mx-2 mt-4">
			<span class="p-float-label">
				<p-dropdown
					#printerIdValue
					[options]="availablePrinterId"
					optionLabel="label"
					optionValue="value"
					optionDisabled="disabled"
					name="printerIdValue"
					[(ngModel)]="kitchenDevice.printerId"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(availablePrinterId)"
					(onChange)="changesToSave = true"
				></p-dropdown>
				<label for="printerIdValue">Printer ID</label>
			</span>
		</div>
	</div>

	<p-tabView>
		<p-tabPanel header="Features">
			<app-kitchen-device-feature-setup
				[(features)]="kitchenDevice.features"
				[kitchenDevice]="kitchenDevice"
				[(changesToSave)]="changesToSave"
				[printerDeviceList]="printerDeviceList"
			></app-kitchen-device-feature-setup>
		</p-tabPanel>
		<p-tabPanel header="Color Profile">
			<app-kitchen-device-color-profile-setup
				[(features)]="kitchenDevice.features"
				[kitchenDevice]="kitchenDevice"
				[(changesToSave)]="changesToSave"
				[(changesToSave)]="changesToSave"
			></app-kitchen-device-color-profile-setup>
		</p-tabPanel>
	</p-tabView>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="kitchenDeviceChange.emit(undefined)"
			(onDeleteChange)="releaseLicense()"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!changesToSave"
			[deletePromptOverride]="true"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
